import * as constants from 'common/constants';

// Builds up a skeleton state object based on banner ids defined in constants file
const getInitialState = () => {
  const state = {};
  const ids = constants.BANNER_IDS;

  for (const id in ids) {
    state[id] = { message: false, isError: false };
  }

  return state;
};

export default (state = getInitialState(), { type, payload = {} }) => {
  const { id, message, isError } = payload;

  switch (type) {
    case constants.BANNER_SHOW: {
      return {
        ...state,
        [id]: { message, isError },
      };
    }
    case constants.BANNER_HIDE:
      return {
        ...state,
        [id]: { message: false, isError: false },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/banner.js